import { useMatches } from "react-router";
import { Link } from "react-router";
import type { CustomRouteHandle } from "@/types/router";
import { Breadcrumb, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Fragment } from "react/jsx-runtime";

type Crumb = { label: string; path?: string };

const useBreadcrumbs = (): Crumb[] => {
	const matches = useMatches();
	const crumbs: Crumb[] = [];

	for (const match of matches) {
		const handle = match.handle as CustomRouteHandle | undefined;
		if (!handle) continue;

		if (handle.breadcrumbs) {
			for (const item of handle.breadcrumbs) {
				const label = typeof item.label === "function" ? item.label(match) : item.label;
				const path = typeof item.path === "function" ? item.path(match) : item.path;
				crumbs.push({ label, path });
			}
		} else if (handle.breadcrumb) {
			const label = typeof handle.breadcrumb === "function" ? handle.breadcrumb(match) : handle.breadcrumb;
			crumbs.push({ label, path: match.pathname });
		}
	}

	return crumbs;
};

export const AppBreadcrumbs = () => {
	const breadcrumbs = useBreadcrumbs();

	if (breadcrumbs.length === 1) {
		return (
			<Breadcrumb className="pl-6 pt-4">
				<BreadcrumbList>
					<BreadcrumbPage className="max-w-20 truncate md:max-w-none">
						{breadcrumbs?.[0]?.label}
					</BreadcrumbPage>
				</BreadcrumbList>
			</Breadcrumb>
		);
	}

	return (
		<Breadcrumb className="pl-6 pt-4">
			<BreadcrumbList>
				{breadcrumbs.map((crumb, idx) => (
					<Fragment key={idx}>
						{crumb.path ? (
							<BreadcrumbList>
								<Link to={crumb.path} className="hover:underline">
									{crumb.label}
								</Link>
							</BreadcrumbList>
						) : (
							<BreadcrumbPage className="max-w-20 truncate md:max-w-none">{crumb.label}</BreadcrumbPage>
						)}
						{idx < breadcrumbs.length - 1 && <BreadcrumbSeparator />}
					</Fragment>
				))}
			</BreadcrumbList>
		</Breadcrumb>
	);
};
